import * as React from "react";

import { Link } from "redux-little-router";

export class PpqCovid19Disclaimer extends React.Component {
    public render() {
        return (
            <>
                <i>
                    The outcome of the above COVID-19 risk assessment has been determined using the
                    &nbsp;<Link href="https://alama.org.uk/covid-19-medical-risk-assessment/" target="_blank">
                        <u>Alama COVID Age predictor tool</u></Link> last updated 9th April 2021.
                    Estimates of personal vulnerability from the COVID-age calculator are derived from published research
                    in populations with no previous infection by, or vaccination against, SARS-CoV-2. As yet, no empirical
                    data is available on whether and how determinants of vulnerability differ in people who have previously
                    been infected or vaccinated. The estimates may be revised if new research is reported that materially changes
                    the balance of available evidence. Risks associated with health conditions are estimated as averages and may
                    vary within a disease category.
                </i>
                <br />
                <br />
                <b><i>
                    If other risks have been identified at pre-placement assessment by our clinical team that affect the advice above then
                    this will be clearly identified in the adjustments section of this report. Any information in the adjustment section
                    will override the advice generated from the COVID-19 risk assessment tool.
                </i></b>
                <br />
                <br />
                <b><i>
                    If the candidate has provided details of their COVID-19 vaccination status then this has been considered and mitigation
                    will have been taken into account when generating the advice above.
                </i></b>
                <br />
                <br />
                <b><i>
                    If an individual’s vaccination status or health condition changes then the advice above may become out of date and may need
                    to be updated. It is important that the Line Manager carries out regular review of the above risk assessment with the employee
                    using their employers own COVID-19 Risk Assessment framework or the Alama COVID age risk tool and maintains accurate records of
                    the outcome and any adjustments that have been agreed.
                </i></b>
                <br />
                <br />
                <b><i>
                    If an employee or employer is not comfortable with the outcome of the above COVID-19 risk assessment then we would also recommend
                    a further risk assessment is carried out or you contact Occupational Health for further support and guidance.
                </i></b>
            </>
        );
    }
}
